// extracted by mini-css-extract-plugin
export default {"container":"style_container__4TWHM","title":"style_title__JKISL","divider":"style_divider__eUUhX","children":"style_children__CbPPy","formFooter":"style_formFooter__14mpq"};